import { render, staticRenderFns } from "./Commands.vue?vue&type=template&id=719e0fcc&scoped=true&"
import script from "./Commands.vue?vue&type=script&lang=js&"
export * from "./Commands.vue?vue&type=script&lang=js&"
import style0 from "./Commands.vue?vue&type=style&index=0&id=719e0fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719e0fcc",
  null
  
)

export default component.exports